import { useState } from "react";
import { BaseFileInput } from "components/DesignSystem/BaseFileInput/BaseFileInput";
import { useToast } from "hooks/useToast";
import { useTypedFormikContext } from "hooks/useTypedFormikContext";
import {
  HandoverDetailFormValues,
  useUploadHandoverAttachmentMutation,
} from "store/apis/salesCrm";

const UPLOAD_FAILED_MESSAGE =
  "Failed to upload the attachment, please try again";

type HandoverAttachmentFieldProps = {
  groupId: string;
};

export const HandoverAttachmentField = ({
  groupId,
}: HandoverAttachmentFieldProps) => {
  const { alertToast } = useToast();
  const { values, setFieldValue } =
    useTypedFormikContext<HandoverDetailFormValues>();
  const [localFile, setLocalFile] = useState<File | null>(null);
  const [uploadAttachment, { isLoading: isUploading }] =
    useUploadHandoverAttachmentMutation();

  const handleDrop = async (dropped: File[]) => {
    const selected = dropped[0];
    if (!selected) return;

    setLocalFile(selected);
    try {
      const response = await uploadAttachment({
        groupId,
        file: selected,
      }).unwrap();
      setFieldValue("attached_document_id", response.uuid);
    } catch {
      setLocalFile(null);
      alertToast({ message: UPLOAD_FAILED_MESSAGE });
    }
  };

  const handleDelete = () => {
    setLocalFile(null);
    setFieldValue("attached_document_id", "");
  };

  const hasExistingAttachment =
    !localFile && Boolean(values.attached_document_id);

  return (
    <div>
      <BaseFileInput
        label="Attachment"
        file={localFile}
        isUploading={isUploading}
        onDrop={handleDrop}
        onDelete={handleDelete}
        block
      />
      {hasExistingAttachment && (
        <p className="t-mb-0 t-mt-1 t-text-body-sm t-text-text-60">
          A document is already attached. Upload a new file to replace it.
        </p>
      )}
    </div>
  );
};
